export default {
    title: "未送达的物品",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "谢谢",
        message: "感谢您的回复。"
    },
    message: "您表示尽管快递员已将物品标记为已送达，但您尚未收到物品。",
    cta: "请按照以下步骤帮助我们解决问题：",
    items: {
        1: {
            message: "点击跟踪链接："
        },
        2: {
            message: "查看递送状态。检查：",
            items: {
                1: "谁签收了包裹",
                2: "如果被退回给寄件人",
                3: "如果包裹正在等待取件"
            }
        },
        3: {
            message: "检查送货通知，其中标明了物品可能被遗留的位置。"
        },
        4: {
            message: "向可能拿走包裹的邻居、亲戚和朋友核实。"
        }
    },
    question: "这是否有助于解决您的配送问题？您现在有收到该商品吗？或者知道谁有它吗？请在下方回复",
    product: {
        name: "项目名称",
        quantity: "数量",
        tracking: "追踪",
    },
    buttons: {
        yes: "是的",
        no: "不",
        saving: "保存"
    }
}